/**
 * Opening a thread from anywhere.
 *
 * Same shape as the palette and the message finder: the shell owns the panel,
 * because it draws over the conversation, and any message in any list can ask
 * for it without each list keeping its own copy.
 */

const watchers = new Set<(messageId: string) => void>();

export function openThread(messageId: string): void {
  watchers.forEach((fn) => fn(messageId));
}

export function onOpenThread(fn: (messageId: string) => void): () => void {
  watchers.add(fn);
  return () => { watchers.delete(fn); };
}
